import { useFeatureFlags } from '@/components/FeatureFlagsContext';

export const isTestCellExactId = (
  testId: string | number,
  testCellCookieProvider: string | undefined
) => {
  /* istanbul ignore next */
  const testIdString = typeof testId === 'string' ? testId : testId.toString();

  return testCellCookieProvider?.split('|').includes(testIdString);
};

export const getFeatureFlagValue = (featureFlag: string): unknown => {
  const featureFlags = useFeatureFlags();
  return featureFlags?.flags[featureFlag]?.value;
};

export const getFeatureFlagValues = <T,>(featureFlags: Array<string>) => {
  return featureFlags.map((flag) => getFeatureFlagValue(flag)) as T;
};
